import React, { PureComponent } from 'react';
import { bool, shape, string, func, arrayOf, number } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { UTButton } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';

import { actionCreators as authActions } from '../../../../../redux/authHandlers';
import AuthFormBox from '../../../../components/AuthFormBox';
import { message } from '../../../../../utils/stringUtils';
import { SIGNUP_IDENTITY_VALIDATION } from '../../../../../constants/reduxForms';
import { signUpUserInformation } from '../../../../../types/userTypes';
import ReturnToSignIn from '../ReturnToSignIn';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import QuestionMapper from './questionMapper';
import IdentityValidation from './layout';
import styles from './styles';

class IdentityValidationContainer extends PureComponent {
  componentDidMount = () => {
    this.props.dispatch(authActions.getIdentityValidationForm(this.props.userInformation));
    gaTrackPageView(ROUTES.SIGN_UP);
  };

  handleSubmit = values => this.props.handleSubmit(values, this.props.userInformation);

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit}
        onKeyDown={handleKeyDown(this.props.handleSubmit)}
        style={styles.container}
      >
        <AuthFormBox title={message('Signup:answerValidationQuestions')}>
          <IdentityValidation
            loading={this.props.loading || !this.props.identityValidationForm}
            identityValidationForm={this.props.identityValidationForm}
          />
        </AuthFormBox>
        {!this.props.loading && (
          <React.Fragment>
            <UTButton
              disabled={this.props.submitFailed && this.props.invalid}
              style={styles.submit}
              type="submit"
            >
              {message('Signup:next')}
            </UTButton>
            <ReturnToSignIn />
          </React.Fragment>
        )}
      </form>
    );
  }
}

IdentityValidationContainer.propTypes = {
  loading: bool.isRequired,
  userInformation: signUpUserInformation,
  handleSubmit: func.isRequired,
  identityValidationForm: arrayOf(
    shape({
      answer: arrayOf(string),
      field_type: string,
      id: number.isRequired,
      order: number.isRequired,
      question: string
    })
  ),
  submitFailed: bool,
  invalid: bool
};

export const questionSelector = createSelector(
  store => store.auth.identityValidationForm,
  identityValidationForm =>
    identityValidationForm &&
    identityValidationForm.questions &&
    identityValidationForm.questions.map(question => QuestionMapper(question))
);

const mapStateToProps = store => ({
  identityValidationForm: questionSelector(store),
  loading: store.auth.identityValidationFormLoading || store.auth.identityAnswersLoading,
  userInformation: store.auth.signUpFlow.userInformation
});

const form = reduxForm({
  form: SIGNUP_IDENTITY_VALIDATION,
  onSubmitFail: errors => scrollToInvalid(errors)
})(Radium(IdentityValidationContainer));

export default connect(mapStateToProps)(form);
